<template>
  <div class="form-panel">     
    <div class="form-panel__header">
      <h2 class="titulo-h2">Datos de Contacto</h2>
    </div>
    <div class="form-panel__body">
      <div class="form-fields">                 
        <div class="form-fields__principal">
          <h2 class="titulo-h3-light">Ingresa tus datos de contacto</h2> 
          <form class="form" action="">  
            <div class="form__group" :class="{'form__group-invalid': $v.form.telefonoResidencia.$error, 'form__group-valid': !$v.form.telefonoResidencia.$invalid}">
              <i class="icon-field icon-field-phone"></i>        
              <label for="telefonoResidencia">Teléfono Residencia</label>
              <input id="telefonoResidencia" type="email" @blur="$v.form.telefonoResidencia.$touch()" v-model="form.telefonoResidencia">
              <div class="form__group-validation" v-if="$v.form.telefonoResidencia.$dirty">
                <p v-if="!$v.form.telefonoResidencia.numeric">Ingresa solo números.</p>
                <p v-if="!$v.form.telefonoResidencia.minLength">El teléfono debe ser de 7 dígitos.</p>
                <p v-if="!$v.form.telefonoResidencia.maxLength">El teléfono debe ser de 7 dígitos.</p>
              </div>
            </div>            
            <div class="form__group" :class="{'form__group-invalid': $v.form.telefonoOtro.$error, 'form__group-valid': !$v.form.telefonoOtro.$invalid}">
              <i class="icon-field icon-field-phoneOffice"></i>        
              <label for="telefonoOtro">Teléfono Oficina</label>
              <input id="telefonoOtro" type="email" @blur="$v.form.telefonoOtro.$touch()" v-model="form.telefonoOtro">
              <div class="form__group-validation" v-if="$v.form.telefonoOtro.$dirty">
                <p v-if="!$v.form.telefonoOtro.numeric">Ingresa solo números.</p>
                <p v-if="!$v.form.telefonoOtro.minLength">Debe ser de al menos 7 dígitos.</p>
                <p v-if="!$v.form.telefonoOtro.maxLength">Debe ser de máximo 10 dígitos.</p>
              </div>
            </div>
            <div v-if="form.telefonoOtro.length > 1 && !$v.form.telefonoOtro.$invalid" class="form__group" :class="{'form__group-invalid': $v.form.extension.$error, 'form__group-valid': !$v.form.extension.$invalid}">
              <i class="icon-field icon-field-parenthesis"></i>        
              <label for="extension">Extensión Oficina</label>
              <input id="extension" type="email" @blur="$v.form.extension.$touch()" v-model="form.extension">
              <div class="form__group-validation" v-if="$v.form.extension.$dirty">
                <p v-if="!$v.form.extension.numeric">Ingresa solo números.</p>
                <p v-if="!$v.form.extension.maxLength">Debe ser de máximo 5 dígitos.</p>
              </div>
            </div>   
            <div class="form__group" :class="{'form__group-invalid': $v.form.email2.$error, 'form__group-valid': !$v.form.email2.$invalid}">
              <i class="icon-field icon-field-email"></i>        
              <label for="email">Segundo Email</label>
              <input id="email" type="email" @blur="$v.form.email2.$touch()" v-model="form.email2">
              <div class="form__group-validation" v-if="$v.form.email2.$dirty">
                <p v-if="!$v.form.email2.email">El formato de correo no es válido.</p>
              </div>
            </div>           
          </form>
        </div>      
        <div class="form-fields__secundario">
          <h2 class="titulo-h3">Contactarme por estos medios</h2> 
          <div class="form-fields__secundario-botones">
            <a class="icon-seleccion icon-seleccion-contactoEmail" :class="!form.envioMail ? 'grayscale' : 'icon-seleccion-seleccionado'" @click="form.envioMail = !form.envioMail" />  
            <a class="icon-seleccion icon-seleccion-contactoTelefono" :class="!form.envioSms ? 'grayscale' : 'icon-seleccion-seleccionado'" @click="form.envioSms = !form.envioSms" />
          </div> 
        </div> 
        <div class="form__group form__group-register">
          <a class="waves-effect waves-light m-btn" tabindex="0" @click="$v.form.$invalid ? $v.form.$touch() : guardarContactoCliente()" @keyup.enter="$v.form.$invalid ? $v.form.$touch() : guardarContactoCliente()">Guardar</a>               
        </div>   
      </div>
    </div>
  </div>   
</template>

<script>
import axios from 'axios';
import { /*required,*/ email, minLength, maxLength, numeric } from 'vuelidate/lib/validators';

export default {
  data(){
    return{
      email: '',
      form:{
        email2: '',
        telefonoResidencia: '',
        telefonoOtro: '',
        extension: '',
        envioMail: false,
        envioSms: false
      },
      ipCliente:''      
    };
  },
  methods:{
    guardarContactoCliente()
    {
      this.$store.dispatch('guardarContactoCliente', this.form)
    },
    get_ip()
    {
      axios.get('https://api.ipify.org?format=json')
        .then(res=>{
          this.ipCliente = res.data.ip;
          //if(res.data.ip == '201.184.244.114'){
          if(res.data.ip == '191.92.20.76'){
          var confirma =confirm('😃😃😃 \n ¡A partir de este momento ya tines acceso a internet!. \n ¿Desea continuar con el registro de sus datos 🤔?');
          if(!confirma){
            location.href ="https://www.lacentral.com.co/";
          }
        }
      }).catch()
    }
  },
  validations: {
    form: {
      email2: {
        email
      },
      telefonoResidencia: {
        numeric,
        minLength: minLength(7),
        maxLength: maxLength(7),
      },
      telefonoOtro: {
        numeric,
        minLength: minLength(7),
        maxLength: maxLength(10)
      },
      extension: {
        numeric,
        maxLength: maxLength(5)
      }
    }    
  },
  mounted() {
    let cliente = this.$store.getters.cliente

    if(cliente.email2) {
      this.form.email2 = cliente.email2
    }

    if(cliente.telefonoResidencia) {
      this.form.telefonoResidencia = cliente.telefonoResidencia
    }

    if(cliente.telefonoMovil) {
      this.form.telefonoMovil = cliente.telefonoMovil
    }
    
    if(cliente.telefonoOtro) {
      if(cliente.telefonoOtro.search(" EXT ") > -1) {
        let partesTelefono = cliente.telefonoOtro.split(" EXT ");
        this.form.telefonoOtro = partesTelefono[0]
        this.form.extension = partesTelefono[1]
      }
      else {
        this.form.telefonoOtro = cliente.telefonoOtro
      }
    }

    this.form.envioMail = cliente.envioMail
    this.form.envioSms = cliente.envioSms
  }
}
</script>